import { render } from "./ModalNotification.vue?vue&type=template&id=5cf192da&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"

import "./ModalNotification.vue?vue&type=style&index=0&id=5cf192da&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf192da"]])

export default __exports__